module.exports = __webpack_public_path__ + "img/high-roi-process.2ad781ff.svg";